import React from 'react';

export const Transfer = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5706 6.35079L8.17525 6.35079L8.17525 8.17541L14.5706 8.17541L14.5706 10.9124L18.2107 7.2631L14.5706 3.61385L14.5706 6.35079ZM1.78906 12.737L5.42919 16.3862L5.42919 13.6493L11.8245 13.6493L11.8245 11.8247L5.42919 11.8247L5.42919 9.08773L1.78906 12.737Z"
      fill="#6E6B8C"
    />
  </svg>
);
